//export const API_URL = "http://77.37.120.62:8085";
export const API_URL = "https://dev.sarrafciraylar.com";

